import { ThemeProvider } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

interface AttendanceConfirmedBottomSheetProps {
  modalState: UseModalState;
}

export function AttendanceConfirmedBottomSheet(props: AttendanceConfirmedBottomSheetProps) {
  const { modalState } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet
        modalState={modalState}
        footer={
          <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={() => {
                modalState.closeModal();
              }}
            >
              View shift details
            </Button>
          </DialogFooter>
        }
      >
        <BottomSheetIllustrationContent
          illustrationType="shift-booked"
          title="See you soon!"
          description="Thanks for checking in. We're excited to see you there!"
        />
      </BottomSheet>
    </ThemeProvider>
  );
}
